import React from "react";
import { Progress } from "@chakra-ui/react";
import BackButton from "@/components/Buttons/BackButton";
import logo from "../../assets/ParrotLogo.png";

interface OnboardingHeaderProps {
  step: number;
  totalSteps: number;
  handleBack: () => void;
  hideBack?: boolean;
}

const OnboardingHeader: React.FC<OnboardingHeaderProps> = ({
  step,
  totalSteps,
  handleBack,
  hideBack: disableBack,
}) => {
  const disableBackCls = disableBack ? "invisible" : "";
  return (
    <div className="flex flex-row w-full h-fit items-center justify-center">
      <div className={`self-start ${disableBackCls}`}>
        <BackButton onBack={handleBack} />
      </div>
      <Progress
        value={((step + 1) / totalSteps) * 100}
        width={"65%"}
        margin={"0 auto"}
        bg={"var(--color-grey-light)"}
        rounded={"full"}
        sx={{
          height: "14px",
          background: "var(--color-grey-light)",
          boxShadow: "none",
          "& > div": {
            background: "var(--color-blue)",
            borderRadius: "9999px",
            position: "relative",
            boxShadow: "0 2px 8px 0 rgba(0,0,0,0.10)",
            overflow: "visible",
            "::before": {
              content: '""',
              position: "absolute",
              left: "6px",
              right: "6px",
              top: "22%",
              height: "18%",
              borderRadius: "9999px",
              background: "rgba(255,255,255,0.15)",
              pointerEvents: "none",
              zIndex: 1,
            },
          },
        }}
      />
      <div className="self-end">
        <img src={logo} alt="Parrot Logo" className="w-9 h-9" />
      </div>
    </div>
  );
};

export default OnboardingHeader;
